import { useContext, useEffect, useState } from "react";
import { FaPen, FaLink, FaLock, FaUnlock } from "react-icons/fa";
import { getData, putData } from "../../lib/utils";
import { Context } from "../contexts/AppContext";
import { useParams } from "react-router-dom";

import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";

const Deliver = () => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();

  console.log("AAAAAAAAAAAAAAAAA ",appState)

  const fullQrRef = useRef(null);
  const guestQrRef = useRef(null);
  
  const [isEditing, setIsEditing] = useState(false);
  const [customUrl, setCustomUrl] = useState(galleryId);
  const [myPlan, setPlan] = useState("imageonly");

  // 🔐 Password States
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);
  const [password, setPassword] = useState("");


  const [isFullEditing, setIsFullEditing] = useState(false);
  const [isGuestEditing, setIsGuestEditing] = useState(false);
  

 

  const [fullUrl, setFullUrl] = useState(galleryId);
  const [guestUrl, setGuestUrl] = useState(`guest/galleries/${galleryId}`);
  const [guestSlug, setGuestSlug] = useState(galleryId);

const [fullPasswordEnabled, setFullPasswordEnabled] = useState(false);
const [guestPasswordEnabled, setGuestPasswordEnabled] = useState(false);

const [fullPassword, setFullPassword] = useState("");
const [guestPassword, setGuestPassword] = useState("");

  const baseUrl = appState?.adminDetails?.domainurl
    ? appState?.adminDetails?.domainurl + "/"
    : process.env.REACT_APP_TO_CLIENT;

  useEffect(() => {
    const fetchGalleryData = async () => {
      const response = await getData(`galleries/gallery/${galleryId}`);
      console.log("rrrrrrrrr ",response.gallery.customurl)
      if (response) {
        if (response.gallery.customurl) {
          setCustomUrl(response.gallery.customurl);
         
        }

        // 🔐 Password Data Load
        if (response.gallery.password) {
          setPassword(response.gallery.password);
          setIsPasswordEnabled(true);
        }
      }
    };

    if (galleryId) {
      fetchGalleryData();
    }
  }, [galleryId]);
 

  const copyLink = (url) => {
  navigator.clipboard.writeText(url);
  alert("✅ Link copied successfully!");
  };
  const normalizeUrl = (url) => url.replace(/\/+/g, "/");
  const onSaveHandler = async () => {

   
    try {
      const json = await putData(`galleries/update-gallery-title/`, {
        customurl: fullUrl,
        galleryId: galleryId,
        password: isPasswordEnabled ? password : "",
        passwordEnabled: isPasswordEnabled,
      });

      if (json) {
        alert(json?.message);
      }
    } catch (error) {
       
      console.error("Error updating:", error);
    }
  };
const downloadQR = (ref, fileName) => {
    const canvas = ref.current.querySelector("canvas");

    const link = document.createElement("a");
    link.download = fileName;
    link.href = canvas.toDataURL("image/png");
    link.click();
};
  return (
<div className="h-[calc(100vh-100px)] grid lg:grid-cols-[1fr_1fr_1fr] gap-2 m-auto  w-full p-4">

  {/* FULL ACCESS */}
  <div className="bg-white rounded-3xl border shadow-lg p-5 flex flex-col">

    <h2 className="text-lg font-bold text-gray-800">
      Full Access Gallery
    </h2>

    <p className="text-sm text-gray-500 mb-4">
      Complete gallery access for clients
    </p>

    {/* URL BOX */}
    <div className="bg-black rounded-2xl p-4 text-white">
      <div className="text-xs text-gray-400 mb-2">URL</div>

  <div className="font-mono text-sm break-all border-e-red-500">
  {baseUrl}
  {myPlan === "imageonly" && "album/"}

{isFullEditing ? (
  <input
    type="text"
    value={fullUrl}
    onChange={(e) => setFullUrl(e.target.value)}
    className="bg-gray-700 border px-1 rounded text-white w-48"
  />
) : (
  <span>{customUrl}</span>
)}
</div>

          <div className="flex gap-3 mt-4">
            {console.log("PPPPPPPPP ",myPlan)}
    <button
  onClick={() =>
    copyLink(
  normalizeUrl(
    `${baseUrl}/${myPlan === "imageonly" ? "album/" : ""}${customUrl}`
  )
)
  }
  className="flex-1 py-2 rounded-xl bg-white text-black font-semibold"
>
  Copy
</button>

        <button className="flex-1 py-2 rounded-xl bg-white/10 text-white" onClick={() => setIsFullEditing(!isFullEditing)}>
          Edit
        </button>
      </div>
    </div>

    {/* PASSWORD */}
    <div className="mt-5">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold">Password Protection</span>

        <button
          onClick={() => setIsPasswordEnabled(!isPasswordEnabled)}
          className={`w-14 h-7 rounded-full transition ${
            isPasswordEnabled ? "bg-green-500" : "bg-gray-300"
          }`}
        >
          <div
            className={`h-6 w-6 bg-white rounded-full shadow transition ${
              isPasswordEnabled ? "ml-7" : "ml-1"
            }`}
          />
        </button>
      </div>

      {isPasswordEnabled && (
        <input
          type="text"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          className="w-full px-3 py-2 border rounded-xl"
        />
          )}
          
           {/* SAVE BUTTON */}
    <button
      onClick={onSaveHandler}
      className="
        mt-6
        w-full
        py-4
        rounded-2xl
        text-black
        font-semibold
        bg-gradient-to-r
        from-amber-500
        to-yellow-600
        shadow-lg
        hover:shadow-xl
        hover:scale-[1.01]
        transition-all
      "
    >
      Save Changes
    </button>
    </div>

   

  </div>

  {/* GUEST ACCESS */}
 <div className="bg-white rounded-3xl border shadow-lg p-5 flex flex-col">

    <h2 className="text-lg font-bold text-gray-800">
      Guest Access Gallery
    </h2>

    <p className="text-sm text-gray-500 mb-4">
      Guest gallery access
    </p>

    {/* URL BOX */}
    <div className="bg-black rounded-2xl p-4 text-white">
      <div className="text-xs text-gray-400 mb-2">URL</div>

      <div className="font-mono text-sm break-all border-e-red-500">
            {baseUrl}guest/galleries/
       {isGuestEditing ? (
  <input
    type="text"
     value={guestSlug}
    onChange={(e) => setGuestSlug(e.target.value)}
    className="bg-gray-700 border px-1 rounded text-white w-48"
  />
) : (
                <span>{galleryId}</span>
)}
      </div>

      <div className="flex gap-3 mt-4">
        <button
              onClick={() => copyLink(`${baseUrl}guest/galleries/${guestSlug}`)}
  className="flex-1 py-2 rounded-xl bg-white text-black font-semibold"
>
  Copy
</button>
        <button className="flex-1 py-2 rounded-xl bg-white/10 text-white"   onClick={() => setIsGuestEditing(!isGuestEditing)}>
          Edit
        </button>
      </div>
    </div>

    {/* PASSWORD */}
    <div className="mt-5">
       
     
          
           {/* SAVE BUTTON */}
    <button
      onClick={onSaveHandler}
      className="
        mt-6
        w-full
        py-4
        rounded-2xl
        text-black
        font-semibold
        bg-gradient-to-r
        from-amber-500
        to-yellow-600
        shadow-lg
        hover:shadow-xl
        hover:scale-[1.01]
        transition-all
      "
    >
      Save Changes
    </button>
    </div>

   

  </div>

  {/* RIGHT QR PREVIEW PANEL */}
<div className="bg-white rounded-3xl border shadow-lg p-5 flex flex-col items-center justify-center">

  <p className="text-sm text-gray-500 mb-6">
    Scan any QR instantly
  </p>

  <div className="flex flex-col items-center gap-8 w-full">

    {/* Full QR */}
    <div
      ref={fullQrRef}
      className="flex flex-col items-center gap-3"
    >
      <button
        onClick={() => downloadQR(fullQrRef, "full-gallery-qr.png")}
        className="px-4 py-2 bg-black text-white rounded-lg"
      >
        Full Access QR Download
      </button>

   <QRCodeCanvas
  value={normalizeUrl(`${baseUrl}/${myPlan === "imageonly" ? "album/" : ""}${customUrl}`)}
  size={180}
  marginSize={4}
  level="H"
/>
    </div>

    {/* Guest QR */}
    <div
      ref={guestQrRef}
      className="flex flex-col items-center gap-3"
    >
      <button
        onClick={() => downloadQR(guestQrRef, "guest-gallery-qr.png")}
        className="px-4 py-2 bg-black text-white rounded-lg"
      >
        Guest QR Download
      </button>

   <QRCodeCanvas
  value={normalizeUrl(`${baseUrl}/guest/galleries/${guestSlug}`)}
  size={180}
  marginSize={4}
  level="H"
/>
    </div>

  </div>

</div>

</div>
  );
};

export default Deliver;